function getDefaultEditorTheme(theme) {
  return {
    paragraph: {
      margin: 0
    },
    list: {
      nested: {
        listitem: {
          listStyleType: "none"
        }
      }
    },
    text: {
      code: {
        backgroundColor: theme?.palette.tidalColors.slateBlueGray[100],
        padding: `0px ${theme?.spacing(0.5)}`
      },
      italic: {
        fontStyle: "italic"
      },
      underline: {
        textDecoration: "underline"
      },
      strikethrough: {
        textDecoration: "line-through"
      },
      underlineStrikethrough: {
        textDecoration: "underline line-through"
      }
    },
    quote: {
      color: theme?.palette.text.primary,
      borderLeftColor: theme?.palette.tidalColors.slateBlueGray[100],
      borderLeftWidth: "2px",
      borderLeftStyle: "solid",
      paddingLeft: theme?.spacing(1),
      marginLeft: 0
    }
  };
}
export {
  getDefaultEditorTheme
};
//# sourceMappingURL=getDefaultEditorTheme.js.map
